import { TechDocPage, TechDocWizardPage } from '../containers/pages';
import { PRODUCT_ID_BAAS, ALLETRAMP_VIDEO_URL } from '../constants';
import { powerupInit } from './alletraMPPagesConfigCommon';
import { gettingStarted } from './alletraMPPagesConfigComm';

const physicalInstallPath = '/physical-install/';
const fieldInstallPath = `${physicalInstallPath}install/`;
const fieldCablePath = `${physicalInstallPath}cable/`;
const fieldUnboxPath = `${physicalInstallPath}unbox/`;
const fieldPlanPath = `${physicalInstallPath}plan/`;

export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_BAAS),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: fieldPlanPath,
    submenuItems: [
      {
        path: fieldPlanPath,
        menuText: 'planDirectAttached',
        exact: true,
        component: TechDocPage,
      },
      {
        path: fieldUnboxPath,
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.FIELD_UNBOX,
        },
      },
      {
        path: fieldInstallPath,
        menuText: 'rack',
        exact: true,
        redirectTo: `${fieldInstallPath}1`,
      },
      {
        path: `${fieldInstallPath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rack',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP1,
              steptitle: 'Install the Rail Shelves',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_INSTALL_STEP2,
              steptitle: 'Install the Chassis',
            },
            {
              videoUrl:
                ALLETRAMP_VIDEO_URL.FIELD_INSTALL_DIRECTATTACHED_PHYSICAL_STEP4,
              steptitle: 'Install the HBAs',
            },
            {
              videoUrl:
                ALLETRAMP_VIDEO_URL.FIELD_INSTALL_DIRECTATTACHED_PHYSICAL_STEP5,
              steptitle: 'Install the Drives',
            },
          ],
        },
      },
      {
        path: fieldCablePath,
        menuText: 'cable',
        exact: true,
        redirectTo: `${fieldCablePath}1`,
      },
      {
        path: `${fieldCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP1,
              steptitle: 'Cable Admin Ports',
            },
            {
              steptitle: 'Cable CDMs',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_DIRECTATTACHED_STEP2,
              steptitle: 'Cable Data Ports',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP3,
              steptitle: 'Cable Hosts',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP4,
              steptitle: 'Cable Power Supplies',
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.POWERUPANDINIT,
        },
      },
    ],
  },
  ...powerupInit,
];
